export const routesMap = {
  LAYOUTS_MAP: 'layouts-map',
  EXAMPLE: 'example',
  NOTIFICATIONS: 'notifications',
  MAIL: 'mail',
  CALENDAR: 'calendar',
  CALENDAR_CREATE_EVENT: 'calendar-create-event',
  CALENDAR_EVENT_TOOLTIP: 'calendar-event-tooltip',
  CALENDAR_EVENT: 'calendar-event-edit',
  CALENDAR_EVENT_TYPE: 'calendar-event-type',
  RESUME: 'resume',
  COVERLETTERS: 'cover-letters',
  OTHERRESUMES: 'other-resumes',
  MYRESUMES: 'my-resumes',
  CREATE_TARIFF: 'create-tariff',
};

export const routesMeta = [
  {
    path: routesMap.LAYOUTS_MAP,
    component: 'PagesMap',
    name: 'Все макеты',
  },
  {
    path: routesMap.EXAMPLE,
    component: 'Example',
    name: 'Пример',
    emptyPage: true,
  },
  {
    path: routesMap.NOTIFICATIONS,
    component: 'Notifications',
    name: 'Уведомления',
  },
  {
    path: routesMap.MAIL,
    component: 'Mail',
    name: 'Почта',
  },
  {
    path: routesMap.CALENDAR_CREATE_EVENT,
    component: 'CalendarCreateEvent',
    name: 'Календарь добавить событие',
  },
  {
    path: routesMap.CALENDAR_EVENT_TOOLTIP,
    component: 'Calendar/CalendarEventTooltip',
    name: 'Календарь тултип события',
  },
  {
    path: routesMap.CALENDAR_EVENT,
    component: 'Calendar/CalendarAddEvent',
    name: 'Календарь создание/редактирование события',
  },
  {
    path: routesMap.CALENDAR_EVENT_TYPE,
    component: 'Calendar/CalendarEditTypeEvent',
    name: 'Календарь редактирование типа события',
  },
  {
    path: routesMap.RESUME,
    component: 'Resume',
    name: 'Резюме',
  },
  {
    path: routesMap.COVERLETTERS,
    component: 'Resume/CoverLetters',
    name: 'Мои сопроводительные письма',
  },
  {
    path: routesMap.OTHERRESUMES,
    component: 'Resume/OtherResumes',
    name: 'Резюме других кандидатов',
  },
  {
    path: routesMap.MYRESUMES,
    component: 'Resume/MyResumes',
    name: 'Мои резюме',
  },
  {
    path: routesMap.CREATE_TARIFF,
    component: 'CreateTariff',
    name: 'Создать тариф',
  },
];
